import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const BUSINESS_INITIAL: BUSINESSES = {
  businesses: [],
  activeBusiness: null,
  businessType: null,
  isLoading: false,
};

const businessSlice = createSlice({
  name: "business",
  initialState: {
    ...BUSINESS_INITIAL,
  },
  reducers: {
    BUSINESS_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Number | Object;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { BUSINESS_UPDATE } = businessSlice.actions;

export { businessSlice, BUSINESS_INITIAL, BUSINESS_UPDATE };
